<template>
  <button role="navigation" type="button" class="btn-back" @click="navigate">
    <div class="btn-back__icon">
      <div v-html="arrow"></div>
    </div>
    <div class="btn-back__text">
      <span v-if="text">{{ text }}</span>
      <span v-else>Torna indietro</span>
    </div>
  </button>
</template>

<script>
import { arrow } from '@/components/svg/common';
export default {
  name: 'btn-back',
  components: {},
  props: {
    text: String,
    path: {
      type: String,
      default: '',
    },
  },
  data() {
    return { arrow };
  },
  methods: {
    navigate() {
      if (this.path) {
        this.$router.push(this.path);
        return;
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.btn-back {
  margin-left: 0;
  color: $cta;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: $font-size-base;
  font-weight: 400;
  line-height: 1;

  width: max-content;
  background: transparent;
  border: none;

  &:hover,
  &:hover * {
    text-decoration: none;
  }

  svg {
    height: 14px;
    margin-right: 8px;
    margin-left: -4px;
    transform: rotate(180deg);
    path {
      fill: $cta;
    }
  }
}
</style>
